/**
 * Quiet "the AI is thinking" indicator: three breathing dots + a label.
 * Announced to screen readers via role="status".
 */
export function ThinkingDots({ label }: { label: string }) {
  return (
    <div role="status" className="flex flex-col items-center gap-3">
      <div className="flex items-center gap-1.5" aria-hidden="true">
        <span className="w-1.5 h-1.5 rounded-full bg-ink-500/60 think-dot" />
        <span className="w-1.5 h-1.5 rounded-full bg-ink-500/60 think-dot" style={{ animationDelay: "0.18s" }} />
        <span className="w-1.5 h-1.5 rounded-full bg-ink-500/60 think-dot" style={{ animationDelay: "0.36s" }} />
      </div>
      <span className="text-[11px] uppercase tracking-[0.22em] text-ink-300">{label}</span>
    </div>
  );
}
